//Variants
import { VariantStyles } from "@/types/variants.type";

interface Variants {
  primary: VariantStyles;
  none: VariantStyles;
}

export enum VariantKeys {
  primary = "primary",
  none = "none",
}

export const variants: Variants = {
  primary: {
    default: "text-white",
    selected: "text-white",
    classes: "text-white",
  },
  none: {
    default: "text-nimbus-blue",
    selected: "text-nimbus-blue",
    classes: "text-nimbus-blue",
  },
};

export type VariantsType = keyof typeof VariantKeys;
